import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Deferred,
  fetchUserInfoDeferred,
  IExceptionAction,
  logException,
  LogException,
  UserEntersApartmentNumber,
  userEntersApartmentNumber,
  userEntersCity,
  UserEntersCity,
  userEntersCoAddress,
  UserEntersCoAddress,
  UserEntersDeliveryPointId,
  userEntersDeliveryPointId,
  userEntersEntrance,
  UserEntersEntrance,
  userEntersFloor,
  UserEntersFloor,
  userEntersHouseNumber,
  UserEntersHouseNumber,
  UserEntersStreetAddress,
  userEntersStreetAddress,
  userEntersZipCode,
  UserEntersZipCode,
} from '../actions/Actions';
import { IState as IAppState, IUserInfo } from '../CustomTypes';
import { Location, History } from 'history';
import {
  Address as MonoAddress,
  IAddress as IMonoAddress,
} from '@snoam/mono-address';

export interface IDispatchProps {
  userEntersCity: UserEntersCity;
  userEntersStreetAddress: UserEntersStreetAddress;
  userEntersHouseNumber: UserEntersHouseNumber;
  userEntersEntrance: UserEntersEntrance;
  userEntersZipCode: UserEntersZipCode;
  userEntersFloor: UserEntersFloor;
  userEntersApartmentNumber: UserEntersApartmentNumber;
  userEntersDeliveryPointId: UserEntersDeliveryPointId;
  userEntersCoAddress: UserEntersCoAddress;
  logException: LogException;
}
export interface IParamProps {
  formSubmitted?: boolean;
  location: Location;
  history: History;
}
export interface IStateProps {
  exceptions?: IExceptionAction[];
  fetchedUserInfo: Deferred<IUserInfo>;
}
export interface IProps extends IParamProps, IDispatchProps, IStateProps {}

export interface IQueryParams {
  deliveryPointId?: string;
  city?: string;
  countryCode?: string;
  entrance?: string;
  flat?: string;
  floor?: string;
  floortype?: string;
  streetname?: string;
  streetno?: string;
  zip?: string;
}

export class Address extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return (
      <MonoAddress
        addressUpdated={(address) => this.handleChange(address)}
        inputsClearable={true}
      />
    );
  }

  private static convertUndefined(value: string) {
    if (!value || value === 'undefined') {
      return '';
    }
    return value;
  }

  private handleChange(address: IMonoAddress) {
    this.props.userEntersStreetAddress(
      Address.convertUndefined(address.street.streetName),
    );
    this.props.userEntersHouseNumber(
      Address.convertUndefined('' + address.streetNumber.streetNo),
    );
    this.props.userEntersCity(Address.convertUndefined(address.street.city));
    this.props.userEntersZipCode(
      Address.convertUndefined(address.streetNumber.postalCode),
    );
    this.props.userEntersCoAddress(
      Address.convertUndefined(address.nameOnDoor),
    );
    this.props.userEntersFloor(
      Address.convertUndefined('' + address.floor.floorNo),
    );
    this.props.userEntersApartmentNumber(
      Address.convertUndefined('' + address.houseHold.flatNo),
    );
    this.props.userEntersDeliveryPointId(
      Address.convertUndefined(
        '' +
          (address.houseHold.deliveryPointId ||
            address.streetNumber.deliveryPointId),
      ),
    );
  }
}

export default connect<IStateProps, IDispatchProps, IParamProps>(
  (state: IAppState) => ({
    exceptions: state.exceptions,
    fetchedUserInfo: fetchUserInfoDeferred,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        logException,
        userEntersApartmentNumber,
        userEntersCity,
        userEntersDeliveryPointId,
        userEntersEntrance,
        userEntersFloor,
        userEntersHouseNumber,
        userEntersStreetAddress,
        userEntersZipCode,
        userEntersCoAddress,
      },
      dispatch,
    ),
)(Address);
